import script from "./ModalVideoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalVideoComponent.vue?vue&type=script&setup=true&lang=js"

import "./ModalVideoComponent.vue?vue&type=style&index=0&id=79361ee5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79361ee5"]])

export default __exports__